import object from 'helpers/object'


export const initialState = {
  orders: [],
  isFetching: true,
}

export const setOrders = (state, payload) => (
  object.setIn(state, [ 'orders' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
